exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_includes/footer/footer.component.css
// module id = ../../../../../src/app/_components/components_includes/footer/footer.component.css
// module chunks = main